import React, { Fragment } from 'react';

import Link from 'app/common/components/Link';
import useConversion from 'app/developer-v3/hooks/useConversion';
import { BASE_DOC_URL_VB } from 'app/developer-v3/constants';

import DismissableMigrationDone from '../DismissableMigrationDone';

type Props = {
  persistId: string;
};

function Done(props: Props) {
  const { persistId } = props;

  const { completedZapsCount } = useConversion();

  return (
    <DismissableMigrationDone
      completedZapsCount={completedZapsCount}
      helpLinks={
        <Fragment>
          Check out{' '}
          <Link
            href={`${BASE_DOC_URL_VB}/manage/maintain-converted-integration`}
            target="_blank"
          >
            documentation for the features of the new platform
          </Link>{' '}
          or our{' '}
          <Link href={`${BASE_DOC_URL_VB}/conversion/overview`} target="_blank">
            project conversion guide
          </Link>
          .
        </Fragment>
      }
      persistId={persistId}
    />
  );
}

export default Done;
